// USA
export const locale = {
	lang: 'en',
	data: {
		TITLE_NAME:'Higher Education Commission, Pakistan',
		DOWNLOAD_MANUAL:'Download Manual',
		HI:'Greetings',
		TRANSLATOR: {
			SELECT: 'Select your language',
		},
		MENU: {
			DASHBOARD:'Dashboard',
			DEGREE_ATTESTATION:'Degree Attestation',
			TRACK_APPLICATIONS:'Track Applications',
			NEW: 'new',
			ACTIONS: 'Actions',
			CREATE_POST: 'Create New Post',
			PAGES: 'Pages',
			FEATURES: 'Features',
			APPS: 'Apps',
		},
		AUTH: {
			GENERAL: {
				OR: 'Or',
				SUBMIT_BUTTON: 'Submit',
				NO_ACCOUNT: 'Don\'t have an account?',
				SIGNUP_BUTTON: 'Sign Up',
				FORGOT_BUTTON: 'Forgot Password ?',
				BACK_BUTTON: 'Back',
				PRIVACY: 'Privacy',
				LEGAL: 'Legal',
				CONTACT: 'Contact',
			},
			LOGIN: {
				TITLE: 'Login Account',
				BUTTON: 'Sign In',
			},
			FORGOT: {
				TITLE: 'Forgotten Password?',
				DESC: 'Enter your email to reset your password',
				SUCCESS: 'Your account has been successfully reset.'
			},
			REGISTER: {
				TITLE: 'Sign Up',
				DESC: 'Enter your details to create your account',
				SUCCESS: 'Your account has been successfuly registered.'
			},
			INPUT: {
				EMAIL: 'Email',
				FULLNAME: 'Fullname',
				PASSWORD: 'Password',
				CONFIRM_PASSWORD: 'Confirm Password',
				USERNAME: 'Username'
			},
			VALIDATION: {
				INVALID: '{{name}} is not valid',
				REQUIRED: '{{name}} is required',
				MIN_LENGTH: '{{name}} minimum length is {{min}}',
				AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
				NOT_FOUND: 'The requested {{name}} is not found',
				INVALID_LOGIN: 'The login detail is incorrect',
				REQUIRED_FIELD: 'Required field',
				MIN_LENGTH_FIELD: 'Minimum field length:',
				MAX_LENGTH_FIELD: 'Maximum field length:',
				INVALID_FIELD: 'Field is not valid',
			}
		},
		COMMON_MESAGES:{
			RESEND_CODE:'Resend Code',
			SECONDS:'Seconds',
			VERIFY_CODE:'Verify Code'
		},
		ACTIONS_BTNS:{
			SAVE_CLOSE:'Save & Close',
			CLOSE:'Close',
			CANCEL_BTN:'Cancel',
			NEXT:'Next',
			PREVIOUS:'Previous',
			UPDATE:'Update',
			ADD:'Add',
			EDUCATION:'Education'
		},
		DASHBOARD:{
			ANNOUNCEMENTS:'Announcements',
			WELCOME:'Welcome',
			BACK:'Welcome back!',
			LAST_LOGIN:'Last Login From :',
			REFRESH_SECTION:'Refresh Section',
			MY_APPLICATIONS:'My Applications',
			TASKS_ASSIGN:'Task Assigned to me',
			SUGGESTED_TO_YOU:'Suggested To You',
			PROFILE_STRENGTH:'Profile Completeness',
			UPDATE_PROFILE:'Update Profile',
			RECENT_ACTIVITIES:'Recent Activities on Latest Application',
			APPLICATION_TABLE:{
				FILTER:'Filter',
				APP_ID:'Application ID',
				APP_TYPE:'Application Type',
				DATE:'Date',
				STATUS:'Status',
				VIEW_APP_STATUS:'View Application Status',
				VIEW_APP:'View Application',
				VIEW_EDIT:'View/Edit',
				DOWNLOAD_FORM:'Download',
				DOWNLOAD_APP_FORM:'Download Application Form',
				NO_RECORD_FOUND:'No records found',
				SAVED:'Saved',
				SUBMITTED:'Submitted',
				PENDING:'Pending',
				APPLICATION_PROCESSING:'Application Processing',
				APPROVED:'Approved',
				PRE_APPROVED:'Provisionally Approved',
				REJECTED:'Rejected',
				REVISION_REQUESTED:'Revision Requested',
				LOCAL_DES_CANCELLED:'Cancelled',
				DAS:'Degree Attestation Service',
				DES:'Local Degree Equivalence Service',
				DESF:'Foreign Degree Equivalence Service',
				COURSERA:'E-Courses/DLSEI',
				
			},
			PROFILE_STRENGTH_SECTION:{
				COMPLETE:'Complete',
				PROFILE_PICTURE:'Profile Picture',
				PERSONAL_DETAILS:'Personal Details',
				CONTACT_DETAILS:'Contact Details',
				ADDRESS_DETAILS:'Address Details',
				EDUCATION_DETAILS:'Education Details',
				PERCENT:'%'
			},
			ASSIGNED_TASKS:{
				FILTER:'Filter',
				NO_RECORD_FOUND:'No records found',
				DAS:'Degree Attestation Service',
				DES:'Degree Equivalence Service',
				DESF:'Foreign Degree Equivalence Service',
				APP_ID:'Application ID:',
				APPOINTMENT_DATE:'Appointment Date:',
				APPOINTMENT_TIME:'Appointment Time:',
				REGIONAL_CENTER:'Regional Center:',
				VIEW_COMMENTS:'View Comments',
				VIEW_TASK_DETAILS:'View Task Details',
				PAY_FEE:'View Payment Details',
			},
			SUGGESTED_SERVICES:{
				APPLY_DAS:'Apply For Degree Attestation Service'
			}
		},
		COMMOM_PROFILE:{
			MAIN_HEADING:'Personal Info',
			DOWNLOAD_MANUAL:'Download Profile Manual',
			EMAIL:'Email',
			PHONE:'Phone',
			LOCATION:'Location',
			MENU_HEADINGS:{
				PERSONAL_INFORMATION:'Personal Information',
				ADDRESS_INFORMATION:'Address Information',
				EDUCATION_INFORMATION:'Education Details',
				CHANGE_PASSWORD:'Change Password',
				CHANGE_EMAIL:'Change Email',
				CHANGE_MOBILE:'Change Mobile Number'
			},
			NEXT_STEP:'Next Step',
			APPLY_FOR_DAS:'Apply For Degree Attestation',
			PERSONAL_DETAILS:{
				MAIN_HEADING:'Tell Us About Yourself',
				MAIN_HEADING2:'Biographical Information',
				MAIN_HEADING3:"Father's Information",
				MAIN_HEADING4:'Nationality Info',
				TITLE:'Title:',
				FIRST_NAME:'First Name:',
				MIDDLE_NAME:'Middle Name:',
				LAST_NAME:'Last Name:',
				CELL_PHONE:'Cell Phone:',
				GENDER:'Gender:',
				RELIGION:'Religion:',
				MARTIAL_STATUS:'Marital Status:',
				DATE_OF_BIRTH:'Date Of Birth:',
				DOMICILE_PROVINCE:'Domicile province:',
				DOMICILE_CITY:'Domicile City:',
				DOMICILE_DISTRICT:'Domicile District:',
				COUNTRY_OF_BIRTH:'Country Of birth:',
				AGE:'Age:',
				FATHER_NAME:'Father Name:',
				FATHER_CNIC:'Father CNIC:',
				FATHER_STATUS:'Father Status:',
				FATHER_CURRENTLY_EMPLOYED:'Father Currently Employed:',
				FATHER_OCCUPATION:'Father Occupation:',
				IDENTIFICATION:'Identification',
				TYPE:'Type',
				COUNTRY:'Country',
				EDIT_DETAILS:'Edit Details',
				INPUTS:{
				TITLE:'Title',
				TITLE_TOOLTIP:'Please select title',
				FIRST_NAME:'First Name',
				FIRST_NAME_TOOLTIP:'Please enter first name',
				MIDDLE_NAME:'Middle Name',
				MIDDLE_NAME_TOOLTIP:'Please enter middle name',
				LAST_NAME:'Last Name',
				LAST_NAME_TOOLTIP:'Please enter last name',
				CELL_PHONE:'Cell Phone',
				CELL_PHONE_TOOLTIP:'Cell Phone',
				GENDER:'Gender',
				RELIGION:'Religion',
				RELIGION_TOOLTIP:'Please select religion',
				MARTIAL_STATUS:'Marital Status',
				DATE_OF_BIRTH:'Date Of Birth',
				DATE_OF_BIRTH_TOOLTIP:'Please select date of birth',
				DOMICILE_PROVINCE:'Domicile province',
				DOMICILE_PROVINCE_TOOLTIP:'Please select domicile province',
				DOMICILE_CITY:'Domicile City',
				DOMICILE_CITY_TOOLTIP:'Please select domicile city',
				DOMICILE_DISTRICT:'Domicile District',
				DOMICILE_DISTRICT_TOOLTIP:'Please select domicile district',
				COUNTRY_OF_BIRTH:'Country Of birth',
				COUNTRY_OF_BIRTH_TOOLTIP:'Please select country of birth',
				AGE:'Age',
				FATHER_NAME:'Father Name',
				FATHER_NAME_TOOLTIP:'Please enter father name',
				FATHER_CNIC:'Father CNIC',
				FATHER_CNIC_TOOLTIP:'Please enter father cnic',
				FATHER_STATUS:'Father Status',
				FATHER_STATUS_TOOLTIP:'Please select father status',
				FATHER_CURRENTLY_EMPLOYED:'Currently Employed',
				FATHER_OCCUPATION:'Father Occupation',
				FATHER_OCCUPATION_TOOLTIP:'Please select father occupation',
				IDENTIFICATION:'Identification Number',
				TYPE:'Type',
				COUNTRY:'Country',
				ACTIONS:'Actions',
				EDIT_PICTURE:'Edit Picture'

				}
			},
			CONTACT_DETAILS:{
				INPUT:{
					SAME_AS_PERMANENT:'Same as Permanent Address',
					ADDRESS:'Address',
					ADDRESS_HINT:'Please enter address',
					DISTRICT:'District',
					DISTRICT_HINT:'Please select district',
					CITY:'City',
					CITY_HINT:'Please select city',
					POSTAL_CODE:'Postal Code',
					POSTAL_CODE_HINT:'Please select postal code',
					COUNTRY:'Country',
					COUNTRY_HINT:'Please select country',
					ADDRESS_DETAILS:'Address Details',
					SAVE_ADDRESS_BTN:'Save Address',
					CANCEL_BTN:'Cancel'
				},
				SAME_AS_PERMANENT:'Same as Permanent Address',
				ADDRESS:'Address:',
				DISTRICT:'District:',
				CITY:'City:',
				POSTAL_CODE:'Postal Code:',
				COUNTRY:'Country:',
				ADDRESS_DETAILS:'Address Details',
				CANCEL_BTN:'Cancel',
				PERMANENT:'Permanent Address',
				MAILING:'Mailing Address',
				CURRENT:'Current Address',
			},
			EDUCATION_DETAILS:{
				ADD_EDUCATION:'Add Education',
				NO_EDUCATION:'No Education Yet',
				ADD_ATLEAST_EDUCATION:'Currently you don’t have any education in system, please add at least one to continue',
				APPLY_DAS:'Apply for Degree Attestation',
				VIEW:'View',
				EDIT:'Edit',
				DELETE:'Delete',
				EQUIVALENCE_ISSUED:'Equivalence Issued',
				VERIFIED:'Verified',
				LOCKED:'Locked',
				EDUCATION_FORM:{
					QUALIFICATION_DETAILS_HEADING:'Qualification Details',
					QUALIFICATION_DETAILS_DESC:'Enter your Qualification details in the below fields',
					DEGREE_CERTIFICATE_HEADING:'Degree / Certificate Awarding Institute Details',
					DEGREE_CERTIFICATE_DESC:'Type your degree and certification details',
					ACADEMIC_DETAILS_HEADING:'Academic Performance Details',
					ACADEMIC_DETAILS_DESC:'Type your acamedic performance details',
					MISSING_UNI_MESSAGE1:'If details of your campus/college/degree title are not available, please contact focal person of your University or lodge a complaint at ',
					MISSING_UNI_MESSAGE2:'and select Pakistan Qualification Register(PQR) in Service tab. To check list of focal person,please',
					INPUTS:{
						QUALIFICATION_LEVEL:'Qualification Level',
						QUALIFICATION_LEVEL_HINT:'Please select qualification level',
						INCOMPLETE_EDUCATION:'Incomplete Education',
						CURRENTLY_ENROLLED:'Currently Enrolled',
						START_DATE:'Start Date',
						START_DATE_HINT:'Please select start date',
						END_DATE_HINT:'Please select end date',
						END_DATE:'End Date',
						EXPECTED_END_DATE:'Expected End Date',
						NAME_ON_DEGREE:'Name on Degree',
						NAME_ON_DEGREE_HINT:'Please enter your name as written on degree',
						COUNTRY:'Country',
						COUNTRY_HINT:'Please select country',
						CITY:'City',
						CITY_HINT:'Please select city',
						DEGREE_AWARDING_INSTITUTE:'Degree Awarding Institute',
						DEGREE_AWARDING_INSTITUTE_HINT:'Please select degree awarding institute',
						DEGREE_AWARDING_INSTITUTE_BOARD:'Degree Awarding Institute / Board',
						DEGREE_AWARDING_INSTITUTE_BOARD_HINT:'Please enter degree awarding institute/board',
						SCHOOL_COLLEGE:'School / College',
						SCHOOL_COLLEGE_HINT:'Please enter school/college name',
						INSTITUTE_SECTOR:'Institute/Sector',
						INSTITUTE_SECTOR_HINT:'Please select institute/sector',
						PROGRAM_TITLE:'Program Title',
						PROGRAM_TITLE_HINT:'Please select program title',
						DISCIPLINE:'Discipline',
						DISCIPLINE_HINT:'Please select discipline',
						OTHER_DEGREE_AWARDING_INSTITUE:'Other Degree Awarding Institute',
						OTHER_DEGREE_AWARDING_INSTITUE_HINT:'Please enter other degree awarding institute',
						UNIVERSITY_NAME_ON_DEGREE:'University Name on Degree',
						UNIVERSITY_NAME_ON_DEGREE_HINT:'Please select university name on degree',
						CAMPUS:'Campus',
						CAMPUS_HINT:'Please select campus',
						CAMPUS_HINT1:'Please enter campus',
						DEPARTMENT:'Department',
						DEPARTMENT_SELECT_HINT:'Please select department',
						DEPARTMENT_ENTER_HINT:'Please enter department',
						DEGREE_TYPE:'Degree Type',
						DEGREE_TYPE_HINT:'Please select degree type',
						SESSION_TYPE:'Session Type',
						SESSION_TYPE_HINT:'Please select session type',
						MAJOR:'Major',
						MAJOR_HINT:'Please select major',
						RESEARCH_WORK:'Research work only',
						AREA_RESEARCH:'Area of Research',
						AREA_RESEARCH_HINT:'Please enter area of research',
						TITLE_DISSERTATION:'Title of Dissertation',
						TITLE_DISSERTATION_HINT:'Please enter title of dissertation',
						REGISTRATION_NUMBER:'Registration/Roll Number',
						REGISTRATION_NUMBER_HINT:'Please enter registration/roll number',
						EDUCATION_SYSTEM:'Education System',
						EDUCATION_SYSTEM_HINT:'Please select education system',
						GRADING_SYSTEM:'Grading System',
						GRADING_SYSTEM_HINT:'Please select grading system',
						TOTAL_GPA:'Total CGPA',
						TOTAL_GPA_HINT:'Please select total gpa',
						TOTAL_MARKS:'Total Marks',
						TOTLA_MARKS_HINT:'Please enter total marks',
						OBTAINED_PERCENTAGE:'Obtained Percentage',
						PLACEHOLDER_OBTAINED_PERCENTAGE:'Enter Obtained Percentage',
						OBTAINED_PERCENTAGE_HINT:'Please enter obtained percentage'
					}
				}
			},
			CHANGE_PASSWORD:{
				SUB_HEADING:'change or reset your account password',
				WARNING_MSG:'Once your password is updated, you will be logged out of EServices Portal! You will need to Sign In back with the updated password.',
				CURRENT_PASSWORD:'Current Password',
				CURRENT_PASSWORD_HINT:'Please enter current password',
				NEW_PASSWORD:'New Password',
				NEW_PASSWORD_HINT:'Please enter password should be atleast 8 characters long,alphanumeric and contain atleast one capital letter',
				CONFIRM_NEW_PASSWORD:'Confirm Password',
				CONFIRM_NEW_PASSWORD_HINT:'Please enter password for confirmation',
			},
			CHANGE_EMAIL:{
				SUB_HEADING:'change your account email',
				PRIMARY_EMAIL:'Primary Email',
				PRIMARY_EMAIL_HINT:'Please enter email in correct format e.g: username@provider.com',
				VERIFICATION_CODE_HINT:'Please enter email verification 5 Digits Code from new Email',
				EMAIL_CODE:'Email Code',
				PLACEHOLDER_EMAIL_CODE:'Enter Email Code',
			},
			CHANGE_PHONE:{
				SUB_HEADING:'change your account Phone Number',
				PRIMARY_PONENUMBER:'Primary Cell Phone Number',
				PRIMARY_PHONENUMBER_HINT:'Please enter phone number in correct format e.g: +92 3472748202',
				PRIMARY_PHONENUMBER_REQUIRED:'Phone is required',
				PRIMARY_PHONENUMBER_ERROR:'Enter valid phone number',
				VERIFICATION_CODE_HINT:'Please Enter Phone Number Verification 5 Digits Code from Registered Phone Number',
				PHONENUMBER_CODE:'Phone Number Code',
				PLACEHOLDER_PHONENUMBER_CODE:'Enter Phone Number Code',
			}
        }
	}
};
